// src/components/common/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { hasPermission, hasAnyPermission, isAuthenticated } from './PermissionUtils';

/**
 * Usage:
 * <ProtectedRoute requiredPermission="Job.View"><JobsModule /></ProtectedRoute>
 * <ProtectedRoute anyOf={['Tallies.View', 'LoL.View']}><TalliesSidebar /></ProtectedRoute>
 * <ProtectedRoute><Dashboard /></ProtectedRoute>  // just checks login, no specific permission
 */
const ProtectedRoute = ({ children, requiredPermission, anyOf }) => {
  // 1. Not logged in at all -> back to login page
  if (!isAuthenticated()) {
    return <Navigate to="/" replace />;
  }

  // 2. anyOf = array of permissions, user needs at least ONE of them
  if (anyOf && anyOf.length > 0) {
    if (!hasAnyPermission(anyOf)) {
      return <Navigate to="/unauthorized" replace />;
    }
    return children;
  }

  // 3. Single required permission
  if (requiredPermission && !hasPermission(requiredPermission)) {
    return <Navigate to="/unauthorized" replace />;
  }

  // 4. No permission specified -> only login check applies (already passed above)
  return children;
};

export default ProtectedRoute;
